import { Button, Stack, Typography } from "@mui/material";

import IconMEI from "../assets/images/logo_signin_microsoft.png";
import IconAAD from "../assets/images/logo_signin_azure.png";
import IconNTT from "../assets/images/logo_signin_ntt.jpg";
import IconAMZ from "../assets/images/logo_signin_amazon.png";
import IconGGL from "../assets/images/logo_signin_google.png";
import IconFBK from "../assets/images/logo_signin_facebook.png";
import IconLNK from "../assets/images/logo_signin_linkedin.png";
import { SignInMethodConfig, SignInMethodKeys } from "@warden-ui/common";

interface signInWithAppTemplateProps {
  config: SignInMethodConfig[];
}

const signInMethodData = {
  [SignInMethodKeys.NA]: {
    icon: null,
    text: "SSO",
  },
  [SignInMethodKeys.MEI]: {
    icon: <img src={IconMEI} alt="Microsoft entra id" />,
    text: "SSO",
  },
  [SignInMethodKeys.AAD]: {
    icon: <img src={IconAAD} alt="Azure Active Directory" />,
    text: "Azure Active Directory",
  },
  [SignInMethodKeys.NTT]: {
    icon: <img src={IconNTT} alt="NTT Docomo" />,
    text: "Authentication Service",
  },
  [SignInMethodKeys.AMZ]: {
    icon: <img src={IconAMZ} alt="Amazon" width={18} />,
    text: "Amazon",
  },
  [SignInMethodKeys.GGL]: {
    icon: <img src={IconGGL} alt="Google" />,
    text: "Google",
  },
  [SignInMethodKeys.FBK]: {
    icon: <img src={IconFBK} alt="Facebook" />,
    text: "Facebook",
  },
  [SignInMethodKeys.LNK]: {
    icon: <img src={IconLNK} alt="LinkedIn" />,
    text: "LinkedIn",
  },
};

export const SignInWithApp = ({ config = [] }: signInWithAppTemplateProps) => {
  const validSignInMethods = config.filter(method => signInMethodData[method.type]);

  return (
    <Stack spacing={2}>
      {validSignInMethods.map((method) => (
        <Button
          key={method.type}
          variant="outlined"
          className="w-100"
          color="gray"
          onClick={() => {
            if (method.onClick) {
              method.onClick(method.identityProvider);
            }
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="w-100"
            spacing={2}
          >
            {signInMethodData[method.type].icon}

            <Typography noWrap={true} className="w-100" fontSize={14} textOverflow="ellipsis" color="#414141">
              Continue with {signInMethodData[method.type].text}
            </Typography>
          </Stack>
        </Button>
      ))}
    </Stack>
  );
};
